// src/utils/media.js (CRA-versio)
import { API_BASE } from "../services/api";
import localBand from "../assets/placeholder-band.webp";

export const AVATAR_PLACEHOLDER = "/media/placeholders/account-avatar.webp";
// Dev/staattinen placeholder frontin public-kansiosta:
 
 export const LOCAL_BAND_PLACEHOLDER = localBand;        // /static/media/...webp
 export const BAND_PLACEHOLDER = LOCAL_BAND_PLACEHOLDER;

const ABS_RE = /^(?:https?:)?\/\/|^(?:data:|blob:)/i;

/**
 * Johda backendin tyvijuuri (origin + mahdollinen basepath) API_BASE:sta poistamalla trailing "/api" (tai "/api/vN").
 * Esim:
 *   - API_BASE = "http://127.0.0.1:8080/api"           -> "http://127.0.0.1:8080"
 *   - API_BASE = "https://x.y/stack/bileboxi/api"       -> "https://x.y/stack/bileboxi"
 *   - API_BASE = "/api" (relatiivinen) + window.origin  -> window.origin
 */
const API_ROOT = (() => {
  try {
    const base =
      (typeof window !== "undefined" && window.__API_BASE__) ||
      API_BASE ||
      "";
    const u = new URL(
      base,
      typeof window !== "undefined" ? window.location.origin : "http://localhost"
    );
    // Poista polun lopusta /api tai /api/vN
    u.pathname = u.pathname.replace(/\/api(?:\/v\d+)?\/?$/i, "");
    // Palauta origin + (mahdollinen) basepath ilman trailing slasheja
    return (u.origin + u.pathname).replace(/\/+$/, "");
  } catch {
    return "";
  }
})();

/**
 * Yhdenmukaistettu absolutointi:
 * - http(s), data:, blob: -> sellaisenaan
 * - /media/* ja /delva-media/* -> aina backendistä (API_ROOT)
 * - /assets/*, /static/* ja LOCAL_BAND_PLACEHOLDER -> frontin originista
 * - muut polut -> prefiksataan backendin tyvijuurella
 */
export function absolutize(url = "") {
  const v = String(url || "").trim();
  if (!v) return "";
  if (ABS_RE.test(v)) return v;

  // Frontin public/ -kansiosta palveltavat (placeholderit, assetit)
  if (
    v.startsWith("/assets/") ||
    v.startsWith("/static/") ||
    v === LOCAL_BAND_PLACEHOLDER
  ) {
    return v; // sama origin kuin front
  }

  // Kaikki /media/* ja /delva-media/* backendin originista + basepathista
  if (v.startsWith("/media/") || v.startsWith("/delva-media/")) {
    const base = API_ROOT || "";
    return `${base}${v}`;
  }

  // Muut backendiin osoittavat polut
  const base = API_ROOT || "";
  return `${base}${v.startsWith("/") ? "" : "/"}${v}`;
}

// Yhteensopivuusalias
export { absolutize as mediaUrl };

/**
 * Profiilikuvan prioriteetti + absolutointi.
 * Fallback paikalliseen placeholderiin, jotta 404 ei tule vaikka API:ssa ei olisi kuvaa.
 */
export function getProfileSrc(band = {}) {
  const src =
    band.profile_image_override ||
    band.profile_image_url ||
    band.profile_image ||
    band.placeholder_image_url ||
    band.placeholder_image ||
    BAND_PLACEHOLDER;

  return absolutize(src || BAND_PLACEHOLDER);
}
